export default __webpack_public_path__ + "static/media/gallery-head-banner.65c85b1a.jpg";